import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

export const toPromise = <T>(obs: Observable<T>) => obs?.pipe(first())?.toPromise();
